/**
 * Moved to `@sizzlenz/shared-frontend/hooks`.
 * Re-exported here so existing `@/lib/hooks/useMetadata` imports keep working.
 */
export {
  useMetadata,
  useItemTags,
  metadataQueryKeys as queryKeys,
} from '@sizzlenz/shared-frontend/hooks';
